/** A tool step's text. With the agent's description, the command and output fold behind one toggle; a legacy
 *  event without one keeps the tool label, the command inline and the output folded. */
export function ToolStepBody({
  label,
  description,
  command,
  output,
  failed,
}: {
  label: string;
  description?: string;
  command?: string;
  output?: string;
  failed: boolean;
}) {
  const folded = description ? command : undefined;
  return (
    <div className="min-w-0" data-testid="troubleshoot-tool-step">
      <span className={description ? 'break-words text-foreground' : 'font-medium text-foreground'}>
        {description ?? label}
        {failed ? ' (failed)' : ''}
      </span>
      {!description && command ? (
        <span className="ml-2 break-all font-mono text-muted-foreground">{command}</span>
      ) : null}
      {folded || output ? (
        <details className="mt-0.5">
          <summary className="cursor-pointer text-xs text-muted-foreground/70 hover:text-muted-foreground">
            {description ? 'Details' : 'Output'}
          </summary>
          <pre className="mt-1 max-h-60 overflow-auto whitespace-pre-wrap break-words rounded bg-muted p-2 text-xs text-muted-foreground">
            {folded ? <span className="font-medium">$ {folded}</span> : null}
            {folded && output ? '\n\n' : ''}
            {output}
          </pre>
        </details>
      ) : null}
    </div>
  );
}
